import React from "react";
import { InstagramEmbed } from "./InstagramEmbed";
import { TikTokEmbed } from "./TikTokEmbed";

import { TwitterEmbed } from "./TwitterEmbed";
import OopsBanner, { NoRecordsBanner } from "../../OopsBanner";

export enum SocialType{
    Instagram="instagram",
    TikTok="tiktok",
    Twitter="twitter",
}

export default function GenericSocialEmbed({socialType, data }: {socialType:string, data: any }) {

    if(data.isStenciled){
        return null;
    }

    let socialLink:string = "";
    let messageString = "";
    switch(socialType){
        case SocialType.Instagram:
            messageString = "No Instagram Link Found. Update your Instagram link in your Vagaro account.";
            socialLink = data.Instagram;
            break;
        case SocialType.TikTok:
            messageString = "No TikTok Link Found. Update your TikTok link in your Vagaro account.";
            socialLink = data.TikTok;
            break;
        case SocialType.Twitter:
            messageString = "No X Link Found. Update your X link in your Vagaro account.";
            socialLink = data.Twitter;
            break;
    }

    if(!socialLink||socialLink.length===0){
        if((window as any).isEditor){

            return <NoRecordsBanner message={messageString} vagaroLink="https://vagaro.com/merchants/settings/marketing/sociallink" />
        }


        return null;
    }

    let split = socialLink.split("/").filter(s=>s.length>1);
    let userId = split.pop();

    if(!userId){
        if((window as any).isEditor){
            return <NoRecordsBanner message="No User Found" />
        }
        return <></>
    }

    switch(socialType){
        case SocialType.Instagram:
            return <InstagramEmbed instaURL={userId} />
        case SocialType.TikTok:
            return <TikTokEmbed tiktokURL={userId} />
        case SocialType.Twitter:
            return <TwitterEmbed twitterURL={userId} />
    }

    return null;
}